import React from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {RiTeamFill} from "react-icons/ri";
import {BsInfoCircle} from "react-icons/bs";
import {ButtonBlue} from "../../../Styles/buttons";
import {useCommun} from "../../../Providers/commun";
import {Container, NewBadge, RichTooltip, TooltipHeader, TooltipText} from "./styles";

/**
 * Botão "MANAGE GROUPS" exibido na tela de grupos da campanha.
 * Mostra um selo "New" e um tooltip rico (ícone + título + descrição); ao clicar,
 * navega para a tela de gerenciamento de grupos (/campaign/:id/manager).
 */
const ManageGroupsButton = () => {
    const {id} = useParams();
    const {t} = useTranslation();
    const {isMobileState} = useCommun();

    const goToManager = () => window.open(`/campaign/${id}/manager`, "_blank", "noopener");

    const tooltipContent = (
        <>
            <TooltipHeader>
                <BsInfoCircle/> {t("words.manage_groups_btn")}
            </TooltipHeader>
            <TooltipText>{t("words.manage_groups_tooltip")}</TooltipText>
        </>
    );

    return (
        <RichTooltip title={tooltipContent} placement="top" arrow>
            <Container>
                <NewBadge>{t("words.new_badge")}</NewBadge>
                <ButtonBlue onClick={goToManager}>
                    {isMobileState ? <RiTeamFill/> : t("words.manage_groups_btn")}
                </ButtonBlue>
            </Container>
        </RichTooltip>
    );
};

export default ManageGroupsButton;
